module.exports = __webpack_public_path__ + "img/icon-1.abf59537.svg";